import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  background?: 'white' | 'gray';
  id?: string;
}
export function Section({
  children,
  className = '',
  background = 'white',
  id
}: SectionProps) {
  const bgColors = {
    white: 'bg-white',
    gray: 'bg-[#F6F7FB]'
  };
  return <section id={id} className={`py-12 md:py-16 px-4 md:px-6 ${bgColors[background]} ${className}`} data-id="element-160">
      <div className="max-w-3xl mx-auto" data-id="element-161">{children}</div>
    </section>;
}